import { FC, ReactNode } from 'react';

import classes from './CardTitle.module.scss';

interface CardTitleProps {
  title: string;
  children?: ReactNode;
}

const CardTitle: FC<CardTitleProps> = ({ title, children }) => {
  return (
    <span className={classes.title}>
      {title}
      {children}
    </span>
  );
};

export default CardTitle;
